import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { Router, RouterModule } from "@angular/router";

import { RouteCacheService } from "../../services/route-cache.service";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: "app-breadcrumb",
  standalone: true,
  imports: [CommonModule, RouterModule, MatButtonModule, MatIconModule],
  templateUrl: "./breadcrumb.component.html",
  styleUrls: ["./breadcrumb.component.scss"],
})
export class BreadcrumbComponent {
  //route = inject(ActivatedRoute);
  router = inject(Router);
  routeCache = inject(RouteCacheService);
  utilasBreadcrumb = this.routeCache.toolsBreadcrumb();
  navigationSignal = this.utilasBreadcrumb.getListContext();
  constructor() {}

  onBack() {
    this.utilasBreadcrumb.onBack();
  }

  navigateTo(route: string, queryParams: any) {
    this.router.navigate([route], { queryParams });
  }
}
